import { useState } from "react";
import { CheckValue } from "../Service/service";

const useLocalStorage = (keyName, defaultValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = localStorage.getItem(keyName);
      if (value) {
        return JSON.parse(value);
      } else {
        if (CheckValue(defaultValue)) {
          localStorage.setItem(keyName, JSON.stringify(defaultValue));
        }
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });
  const setValue = (newValue) => {
    try {
      if (CheckValue(newValue)) {
        localStorage.setItem(keyName, JSON.stringify(newValue));
      } else {
        localStorage.removeItem(keyName);
      }
    } catch (err) {
      console.error(err);
    }
    setStoredValue(newValue);
  };
  return [storedValue, setValue];
};

export default useLocalStorage;